import { apiConvidados } from './api'

let scheduled = false

/** Após o shell: aquece a lista de convidados (fluxo viral). */
export function schedulePrefetchViralHubData(): void {
  if (scheduled || typeof window === 'undefined') return
  scheduled = true

  const run = () => {
    void apiConvidados(1).catch(() => {
      /* ignore */
    })
  }

  const ric = window.requestIdleCallback?.bind(window)
  if (ric) {
    ric(() => run(), { timeout: 4000 })
    return
  }
  window.setTimeout(run, 600)
}
